import { Howl } from 'howler'
import { dispatchEvent } from '@nrk/dh-basis-common'
import { renderPlayButtonText } from './play-button.html.js'
import styles from './lydlogg.module.css'

function huffman(count, repeatStr) {
  var e = repeatStr
  for (let i = count; i > 1; i--) e += repeatStr
  return e
}

const silence = `data:audio/mpeg;base64,//uQx${huffman(23, 'A')}WGluZwAAAA8AAAACAAACcQCA${huffman(
  16,
  'gICA',
)}${huffman(66, '/')}8AAABhTEFNRTMuMTAwA8MAAAAAAAAAABQgJAUHQQAB9AAAAnGMHkkI${huffman(
  320,
  'A',
)}//sQxAADgnABGiAAQBCqgCRMAAgEAH${huffman(
  15,
  '/',
)}7+n/9FTuQsQH//////2NG0jWUGlio5gLQTOtIoeR2WX////X4s9Atb/JRVCbBUpeRUq${huffman(
  18,
  '/',
)}9RUi0f2jn/+xDECgPCjAEQAABN4AAANIAAAAQVTEFNRTMuMTAw${huffman(97, 'V')}Q==`

export class Lydlogg extends HTMLElement {
  #unlocked = false
  static get observedAttributes() {
    return ['playing', 'progress']
  }

  connectedCallback() {
    this.sound = new Howl({
      src: [this.mp3],
      onplay: this._handlePlay,
      onpause: this._handleStop,
      onstop: this._handleStop,
      onend: this._handleStop,
    })
    this.addEventListener('click', this._handleTogglePlay)
  }

  attributeChangedCallback(name, prevValue, newValue) {
    if (newValue === prevValue) {
      return
    }
    if (name === 'playing') {
      this.playButton.innerHTML = renderPlayButtonText(this.playing)
      this._updateActiveText()
    } else if (name === 'progress') {
      this._updateActiveText()
    }
  }

  #unlock() {
    const audio = new Audio(silence)
    audio.play()
    this.#unlocked = true
  }

  _updateActiveText = () => {
    const progress = this.progress
    for (const caption of this.captions) {
      try {
        const timeIn = parseFloat(caption.getAttribute('data-in') ?? '-1')
        caption.classList.toggle(styles.active, progress >= timeIn)
      } catch (e) {
        //
      }
    }
  }

  _handlePlay = () => {
    dispatchEvent(this, 'dh-lydlogg-play', { mp3: this.mp3, progress: this.progress })
    if (!this.#unlocked) {
      this.#unlock()
    }
    this.playing = true
    this.startProgress()
  }

  _handleStop = () => {
    dispatchEvent(this, 'dh-lydlogg-stop', { mp3: this.mp3, progress: this.progress })
    this.playing = false
    this.stopProgress()
  }

  _handleTogglePlay = (e) => {
    e.stopPropagation()
    if (this.playing) {
      this.sound.pause()
    } else {
      this.sound.play()
    }
  }

  startProgress = () => {
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.progress = this.sound.seek()
      }, 300)
    }
  }

  stopProgress = () => {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  get playButton() {
    return this.querySelector('button')
  }

  get captions() {
    return this.querySelectorAll(`.${styles.item}`)
  }

  get mp3() {
    return this.getAttribute('mp3')
  }

  get playing() {
    return this.hasAttribute('playing')
  }

  set playing(value) {
    if (value) {
      this.setAttribute('playing', '')
    } else {
      this.removeAttribute('playing')
    }
  }

  get progress() {
    return parseFloat(this.getAttribute('progress') ?? '0')
  }

  set progress(value) {
    this.setAttribute('progress', value.toFixed(2))
  }
}
